import { render, staticRenderFns } from "./BeWizard.vue?vue&type=template&id=4fa392a8&"
import script from "./BeWizard.vue?vue&type=script&lang=js&"
export * from "./BeWizard.vue?vue&type=script&lang=js&"
import style0 from "./BeWizard.vue?vue&type=style&index=0&id=4fa392a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports